export default __webpack_public_path__ + "static/media/Community-Hands-Overlay.2fda1271.svg";